<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title
				:title="getMessage_(screen.menuTitle)"
				useFaivorite
				:faivorite="screen.favoriteYn === 'Y'"
				:onFavorite="onFavorite"
			/>
		</template>
		<template v-slot:content>
			<graph-info-contentView ref="content" :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/GraphInfo/store/helpers';
import GraphInfoContentView from './Content/GraphInfoContentView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		//화면진입시 초기화
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
		console.clear();
	},
	components: {
		GraphInfoContentView
	},
	data() {
		return {
			title: '그래프샘플페이지',
			faivorite: true,
			screen: {}
			// locations: ['시스템관리', '다국어/메시지 관리']
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
